import React, { useState } from 'react'

import * as Api from '../../../api'




import { DataGrid, GridColDef } from '@mui/x-data-grid';
import ProgressIndicator from 'tsui/ProgressIndicator'
import ErrorMessage from 'tsui/ErrorMessage'
import { Button, Grid, Typography } from '@mui/material'
import * as MessagesApi from 'api/messages'
import MessagesDetailsTab from './MessagesDetailsTab'
import ReadMessages from './ReadMessages';
import moment from 'moment';

import { debounce } from '@mui/material/utils';
import {
    DataGridPro,
    GridFetchRowsParams,
    useGridApiRef,
} from '@mui/x-data-grid-pro';
// import {
//     createFakeServer,
//     loadServerRows,
//     UseDemoDataOptions,
// } from '@mui/x-data-grid-generator';


export default function MessagesTabPro() {

    const mounted = React.useRef(false);
    let [dataRequested, setDataRequested] = React.useState(false);
    let [error, setError] = React.useState<Error | null>(null);
    const apiRef = useGridApiRef();

    let [messages, setMessages] = React.useState<MessagesApi.ApiMessage[] | null>(null);
    let [messagesDetailsId, setMessagesDetailsId] = React.useState<string | null>(null);
    let [isReadMessage, setIsReadMessage] = React.useState<string | null>(null);
    const [rowCount, setRowCount] = React.useState(0);

    React.useEffect(() => {

        // Api.requestAdmin<MessagesApi.ApiMessage[]>('messages', 'fetch_data_grid_pro', { firstRowToRender: '0', lastRowToRender: '5' }).then(messages => {
        Api.requestAdmin<any>('messages', 'fetch_data_grid_pro', { firstRowToRender: '0', lastRowToRender: '3' }).then(d => {

            if (d.messagesData) {
                setMessages(d.messagesData)
            }
            if (d.messagesCount) {
                setRowCount(d.messagesCount)
            }

        }).catch(err => alert(err));

    }, []);



    const handleFetchRows = React.useCallback(
        async (params: GridFetchRowsParams) => {

            // Api.requestAdmin<MessagesApi.ApiMessage[]>('messages', 'fetch_data_grid_pro', { firstRowToRender: params.firstRowToRender.toString(), lastRowToRender: params.lastRowToRender.toString() }).then(d => {
            let d = await Api.requestAdmin<any>('messages', 'fetch_data_grid_pro', { firstRowToRender: params.firstRowToRender.toString(), lastRowToRender: params.lastRowToRender.toString() });
            
            apiRef.current.unstable_replaceRows(params.firstRowToRender, d.messagesData);


            //}).catch(err => alert(err));

        },
        [apiRef],
    );

    const debouncedHandleFetchRows = React.useMemo(
        () => debounce(handleFetchRows, 200), [handleFetchRows],
    );


    if (error) {
        console.debug(error);
        return <ErrorMessage error={error} />
    }


    if (!messages) {
        return <ProgressIndicator title='Loading...' />
    }


    return <>

        {/* <Grid container height='100%'> */}
        <Grid height='100%'>
            <Grid item xs={10} md={10}>
                <Typography>Total Messages:&nbsp;{messages.length}</Typography>
            </Grid>
            <Grid item xs height='100%'>
                <DataGridPro
                    sx={{
                        color: theme_.dataGridTextColor
                    }}
                    columns={[
                        { field: 'messageId', headerName: 'Msg ID', headerAlign: 'center', width: 80 },
                        { field: 'senderEmail', headerName: 'Sender Email', headerAlign: 'center', width: 200 },
                        // { field: 'senderUserId', headerName: 'UserId', headerAlign: 'center', width: 80 },
                        { field: 'subject', headerName: 'Subject', headerAlign: 'center', width: 150, flex: 1 }, // width: 600 },
                        { field: 'content', headerName: 'Text', headerAlign: 'center', width: 300, flex: 1 }, // width: 600 },
                        // { field: 'status', headerName: 'Status', headerAlign: 'center', minWidth: 10, flex: 1 }, // width: 600 },
                        // { field: 'dateCreated', headerName: 'Time', headerAlign: 'center', width: 100, flex: 1 }, // width: 600 },
                        {
                            field: 'dateCreated', type: 'dateTime', headerName: 'Message Time', headerAlign: 'center', flex: 1, valueFormatter: params =>
                                // moment(params?.value).format("DD.MM.YYYY hh:mm A"),
                                moment(params?.value).format("DD.MM.YYYY HH:mm"),
                        },
                        // { field: 'isRead', headerName: 'Is Read', headerAlign: 'center', minWidth: 300, flex: 1 }, // width: 600 },
                        {
                            field: 'isRead', headerName: 'Is Read', headerAlign: 'center', width: 100, renderCell: (params) => {
                                return <>
                                    {params.row.isRead === true && <Typography sx={{ color: 'green' }}>R</Typography>}
                                    {params.row.isRead === false && <Typography sx={{ color: 'red' }}>R</Typography>}

                                </>;
                            }
                        },
                        {
                            field: 'isReadAction', type: 'actions', headerName: 'Read', width: 100, renderCell: (cell) => {
                                return <>
                                    <Button variant='contained' onClick={() => setIsReadMessage(cell.id as string)}>Read</Button>
                                </>;
                            }
                        },
                        {
                            field: '', type: 'actions', headerName: 'Actions', width: 100, renderCell: (cell) => {
                                return <>
                                    <Button variant='contained' onClick={() => setMessagesDetailsId(cell.id as string)}>Details</Button>
                                </>;
                            }
                        }, // width: 600 },
                    ]}
                    rows={messages}
                    apiRef={apiRef}
                    hideFooterPagination
                    rowCount={rowCount}
                    sortingMode="server"
                    filterMode="server"
                    rowsLoadingMode="server"
                    onFetchRows={debouncedHandleFetchRows}
                    experimentalFeatures={{
                        lazyLoading: true,
                    }}

                    getRowId={row => row.messageId}
                />
            </Grid>
        </Grid>


        {/* {showAddUser && <AddUserDialog onClose={() => setShowAddUser(false)}></AddUserDialog>} */}
        {messagesDetailsId && <MessagesDetailsTab messageId={messagesDetailsId} onClose={() => setMessagesDetailsId(null)} />}
        {isReadMessage && <ReadMessages messageId={isReadMessage} onClose={() => { setIsReadMessage(null); setDataRequested(false) }}></ReadMessages>}

    </>;


}


